<script>
  import { onMount } from 'svelte'
  import Metrics from '../Metrics.svelte'
  import DataTable from '../DataTable/DataTable.svelte'
  import { Button } from 'smelte'
  import { push, pop } from 'svelte-spa-router'
  import { sparePartsAPI } from './api'

  const api = new sparePartsAPI()

  let selected = null
  let data = []
  let columns = [
    {
      label: 'Project number', field: 'su_erp_proj', add: '', w: '40', iconAfter: true
    },
    {
      label: 'Sales office', field: 'country_key', add: '', w: '32', iconAfter: true
    },
    {
      label: 'End user company', field: 'eu_name', add: '', iconAfter: true
    }
  ]

  onMount(() => {
    api.getProjectList()
      .then(res => {
        data = res.data
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
  })

  function detailsOpenHandler ({detail}) {
    console.log('[DEBUG] details open handler', detail)
    push('/spare-part-list-generator/' + encodeURIComponent(detail['su_erp_proj']))
  }

</script>

<Metrics />

<div class="container mx-auto px-8 pt-1 pb-8 bg-white">

  <div class="flex header bg-white my-12">
    <div class="text-xl text-black text-left flex-grow">
      <span>SPARE PART LIST GENERATOR</span>
    </div>
  </div>

  <div class="flex header bg-white my-12">
    <div class="text-lg text-gray-700 text-left flex-grow">
      <p class="mb-2">
        This tool allows you to generate the FlexLink standard spare part list for your project,
        in only a few steps.
      </p>
      <p class="mb-2">
        To generate the spare part list for a specific project,
        please select the project you want from installed base below.
      </p>
    </div>
  </div>

  <div class="overflow-x-auto text-gray-700 overflow-y-auto" style="max-height: 500px">

    <DataTable {columns} {data}
               activationColumn={0}
               current={selected}
               selectable={false}
               minWidth={600}
               on:dblclick={detailsOpenHandler} />

  </div>

  <div class="mt-8 mb-5 w-full text-center">
    <Button text color="red" on:click={() => { pop() }}>GO Back</Button>
  </div>
</div>